module.exports = __webpack_public_path__ + "img/6.73783d78.png";